import { useNavigate } from "react-router-dom";

const ScaleYourAISolutions = ({ type, inputs, setInputs, onNext, onBack }) => {
  const navigate = useNavigate();
  const handleFormInputsChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  return (
    <div className="flex items-center justify-center mt-4">
      <div>
        <div className="container-main">
          <div className="container !mt-0">
            <div className="">
              <div className="text-center">
                <h1 className="text-[30px] font-medium">
                  Scale Your AI Solutions
                </h1>
                <p className="mt-4">
                  Help us understand your team's needs for optimal AI
                  integration
                </p>
              </div>

              <div className="mt-8 max-w-[420px] mx-auto">
                <form onSubmit={onNext} className="loginForm">
                  <div className="mb-4">
                    <input
                      type="text"
                      name="business_name"
                      placeholder="Business Name"
                      value={inputs.business_name}
                      onChange={handleFormInputsChange}
                      className="w-full !py-3"
                    />
                  </div>

                  <div className="mb-4">
                    <input
                      type="text"
                      name="phone_number"
                      placeholder="Mobile number (Optional)"
                      size="large"
                      value={inputs.phone_number}
                      onChange={handleFormInputsChange}
                      className="w-full !py-3"
                    />
                  </div>

                  <div className="mt-8" style={{ textAlign: "right" }}>
                    <button
                      style={{
                        width: "100%",
                        padding: "12px",
                        borderRadius: "5px",
                      }}
                      size="large"
                      type="submit"
                      disabled={!inputs.business_name}
                      className={`${!inputs.business_name
                        ? "!bg-muted border !border-border !text-muted-foreground"
                        : "bg-foreground text-background hover:bg-foreground/90 transition-colors"
                        }`}
                    >
                      {"Start Training Your AI"}
                    </button>

                  </div>
                  <span onClick={onBack ? onBack : () => navigate(-1)} className='text-muted-foreground text-[12px] flex justify-start mt-8 cursor-pointer'>
                    ← Go back
                  </span>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScaleYourAISolutions;
